import React, { useState } from 'react';
import { FaTrain } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Card from '../components/Common/Card';
import PNRForm from '../components/Features/PNRChecker/PNRForm';
import styles from './PNRStatusPage.module.css';

const PNRStatusPage: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handlePNRSubmit = async (pnr: string) => {
    setIsLoading(true);
    // Navigate to the PNR result page
    navigate(`/pnr-status/${pnr}`);
    setIsLoading(false);
  };

  return (
    <div className={styles.pnrStatusPage}>
      <div className="container">
        {/* Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>
            <FaTrain className={styles.titleIcon} />
            PNR Status Checker
          </h1>
          <p className={styles.subtitle}>
            Check your PNR status instantly with detailed passenger information
          </p>
        </div>

        {/* PNR Form */}
        <Card className={styles.formCard}>
          <PNRForm onSubmit={handlePNRSubmit} isLoading={isLoading} />
        </Card>

        {/* Info Section */}
        <div className={styles.infoSection}>
          <Card className={styles.infoCard}>
            <h3 className={styles.infoTitle}>How to Check PNR Status?</h3>
            <ol className={styles.infoList}>
              <li>Enter your 10-digit PNR number in the box above</li>
              <li>Click on "Check PNR Status" button</li>
              <li>View detailed journey and passenger information instantly</li>
            </ol>
          </Card>

          
        </div>
      </div>
    </div>
  );
};

export default PNRStatusPage;